import {
  ActionType,
  ActionTypes,
  KeyContent,
  KeyType,
  KeyTypes,
  SavedUserData,
} from './types'

const initKey = (key: string): KeyContent => {
  const DEFAULT_VALUES = {
    [ActionTypes.DECLARED]: { overallCount: 0 },
    [ActionTypes.BROWSING]: { overallCount: 0 },
  } as KeyContent

  const FUNNEL_VALUES = {
    [ActionTypes.USER_STARTED_QUIZ]: { overallCount: 0 },
    [ActionTypes.USER_COMPLETED_QUIZ]: { overallCount: 0 },
    [ActionTypes.USER_VIEWED_PLANS]: { overallCount: 0 },
    [ActionTypes.USER_VIEWED_CART_EMAIL]: { overallCount: 0 },
    [ActionTypes.USER_CREATED_ACCOUNT]: { overallCount: 0 },
    [ActionTypes.USER_VIEWED_PAYMENT_METHODS]: { overallCount: 0 },
    [ActionTypes.USER_SELECTED_PAYMENT_METHOD]: { overallCount: 0 },
    [ActionTypes.USER_CLICKED_PLACE_SECURE_ORDER]: { overallCount: 0 },
    [ActionTypes.USER_COMPLETED_ORDER]: { overallCount: 0 },
  } as KeyContent

  return key === KeyTypes.FUNNEL_STATE ? FUNNEL_VALUES : DEFAULT_VALUES
}

interface InitUserData {
  key: KeyType
  data: SavedUserData
  id: string
  actionType: ActionType
  eventName: string
}

export const initUserData = ({
  key,
  data,
  id,
  actionType,
  eventName,
}: InitUserData): SavedUserData => {
  const newData = { ...data }

  if (!data[id]) newData[id] = initKey(key)

  const eventsData = newData[id][actionType]

  if (!eventsData[eventName]) {
    eventsData[eventName] = {
      count: 0,
    }
  }

  return newData
}
